import presentationDefaultState from './presentation'
import audienceDefaultState from './audience'
import slideDefaultState from './slide'
import myQuizAnswersDefaultState from './myQuizAnswers'

export default {
  ...presentationDefaultState,
  ...audienceDefaultState,
  ...slideDefaultState,
  ...myQuizAnswersDefaultState,
}
